<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f012-01.jpg" width="80%"/></p>
<p class="caption">The native large-leaved limes in King’s Wood produce new trunks from ancient stools. They grow in abundance close to the Cistercian abbey.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 17_chapter023.vue?5b35a97e